import { SimpleFetchController } from "./fetch-controller";
export { SimpleFetchController as SimpleFetch };
